import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButton, Link, Stack, Typography } from '@mui/material';
import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import { ReactComponent as NotesIcon } from '../../../../../../public/svgs/edit.svg';
import theme from '../../../../../theme';
import { Dashboard } from '../../../../../types/files';
import CommentaryModal from '../../../../modals/tables/dashboards/rows/CommentaryModal';
import useStyles from "../styles";

const edjsParser = require("editorjs-parser").default;
const parser = new edjsParser();

const CommentaryCell: React.FC<{ dashboard: Dashboard }> = ({ dashboard }) => {
    const classes = useStyles();
    const [commentaryModalOpen, setCommentaryModalOpen] = useState<boolean>(false);
    const [commentaryNote, setCommentaryNote] = useState<string>('');
    const latestUpdateRef = useRef<HTMLElement>(null);

    const commentary = useMemo(() =>
        dashboard?.notes?.find(note => note.title === `$['Commentary']`)
        , [dashboard?.notes]);

    useEffect(() => {
        setCommentaryNote(new DOMParser().parseFromString(parser.parse({ blocks: (JSON.parse(commentary?.data || '[]') as any[]).slice(1) }), 'text/html')?.body?.textContent?.trim() || '');
    }, [commentary]);

    return (<>
        <Stack width="100%" ref={latestUpdateRef}>
            {!!commentaryNote.length ? (
                <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                    <Stack direction="row" spacing={0.5} alignItems="center" justifyContent="flex-start">
                        <NotesIcon style={{ width: 20, height: 20, fill: '#94a3b8' }} />
                        <Typography className={classes.url} sx={{ maxWidth: '20ch !important' }}>
                            {commentaryNote}
                        </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="stretch" justifyContent="flex-end">
                        <IconButton disableRipple
                            onClick={() => setCommentaryModalOpen(true)}
                            sx={{ padding: 'unset !important' }}>
                            <ExpandMoreIcon className={classes.icon} sx={{ fill: theme.colors.neutral['500'] }} />
                        </IconButton>
                    </Stack>
                </Stack>
            ) : (
                <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start">
                    <Link fontFamily="Lato" fontSize="0.9rem" fontWeight={500}
                        color={`${theme.colors.neutral['500']} !important`}
                        underline='hover'
                        onClick={() => setCommentaryModalOpen(true)}
                        sx={{ cursor: 'pointer' }}>
                        {'Add context...'}
                    </Link>
                </Stack>
            )}
        </Stack>
        {commentaryModalOpen && (
            <CommentaryModal
                open={commentaryModalOpen}
                dashboard={dashboard}
                newCommentary={!commentaryNote.length}
                anchorElement={latestUpdateRef.current}
                onClose={() => setCommentaryModalOpen(false)} />
        )}
    </>);
}

export default memo(CommentaryCell);
